import { isBootFeatureEnabled } from 'owa-metatags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import getNonBootUserConfiguration from '../getNonBootUserConfiguration';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export async function getMaxRecipientsPerMessage(): Promise<number | undefined> {
    if (isBootFeatureEnabled('fwk-delay-policy-tips')) {
        const nonBootUserConfig = await getNonBootUserConfiguration(
            getGlobalSettingsAccountMailboxInfo()
        ).catch(() => undefined);
        return nonBootUserConfig?.MaxRecipientsPerMessage;
    }

    return getUserConfiguration().MaxRecipientsPerMessage;
}
